import React from 'react';
import styled from 'styled-components';
import DefaultLayout from '../layouts/DefaultLayout';
import rccIcon from '../assets/content-icons/indication-icons-rcc.png';
import { Body, DesktopOnly, H3, H4, H3Style, H4Style, H6, HeaderH5Style, Reference, Ul, MobileOnly, PreviewTitleStyle, TableSpan, H5, HeaderH6 } from '../util/typography';
import hero from '../assets/hero-banners/rcc-image-desktop.png';
import PageIntroduction from '../components/PageIntroduction';
import Section from '../components/Section';
import Subsection from '../components/Subsection';
import * as colors from '../util/colors';
import Chart from '../components/Chart';
import mobileChart from '../assets/content-icons/rcc/rcc-581-study-design-mobile.png';
import mobileNonChart from '../assets/content-icons/rcc/rcc-knb61-study-design-mobile.png';
import desktopChart from '../assets/content-icons/rcc/rcc-581-study-design-desktop.png';
import desktopNonChart from '../assets/content-icons/rcc/rcc-knb61-study-design-desktop.png';
import moblieCharacter from '../assets/content-icons/rcc/rcc-581-study-characteristics-mobile.png';
import desktopCharacter from '../assets/content-icons/rcc/rcc-581-study-characteristics-desktop.png';
import moblieNonCharacter from '../assets/content-icons/rcc/rcc-knb61-study-characteristics-mobile.png';
import desktopNonCharacter from '../assets/content-icons/rcc/rcc-knb61-study-characteristics-desktop.png';
import mobileNonEfficacyChart from '../assets/content-icons/rcc/rcc-knb61-orr-graph-mobile.png';
import desktopNonEfficacyChart from '../assets/content-icons/rcc/rcc-knb61-orr-graph-desktop.png';
import Table from '../components/Table';
import PrimaryCallout from '../components/PrimaryCallout';
// import downloadIcon from '../assets/utility/icons/icon-button-download.svg';
import desktopEfficacyChart from '../assets/content-icons/rcc/rcc-pfs-graph.png';
import mobileEfficacyChart from '../assets/content-icons/rcc/rcc-pfs-graph-mobile.png';
import mobileOrrChart from '../assets/content-icons/rcc/rcc-orr-graph-mobile.png';
import desktopOrrChart from '../assets/content-icons/rcc/rcc-orr-graph-desktop.png';
import modilePdImage from '../assets/content-icons/rcc/rcc-ar-table-mobile.png';
import commonArDesktop from '../assets/content-icons/rcc/rcc-most-common-ar-graph-desktop.png';
import commonArMobile from '../assets/content-icons/rcc/rcc-most-common-ar-graph-mobile.png';
import rccOsIcon from '../assets/content-icons/rcc/rcc-os-badge.png';
import rccNonOsIcon from '../assets/content-icons/rcc/rcc-knb61-dor-badge.png';
import rccOsChartDesktop from '../assets/content-icons/rcc/rcc-os-fa-graph-desktop.png';
import rccOsChartMobile from '../assets/content-icons/rcc/rcc-os-fa-graph-mobile.png';
import RelatedContent from '../components/RelatedContent';
import Accordion from '../components/Accordion';
import isaac from '../assets/images/isaac.png';
import pfs from '../assets/content-icons/rcc/pfs-desktop.png';
import pfsMobile from '../assets/content-icons/rcc/pfs-mobile.png';
import pfsFinalMobile from '../assets/content-icons/rcc/pfs-final-data-mobile.png';
import pfsFinal from '../assets/content-icons/rcc/pfs-final-data-desktop.png';
import medianTime from '../assets/content-icons/rcc/median-time-desktop.png';
import medianTimeMobile from '../assets/content-icons/rcc/median-time-mobile.png';
import orrFinal from '../assets/content-icons/rcc/rcc-orr-final-desktop.png';
import orrFinalMobile from '../assets/content-icons/rcc/rcc-orr-final-mobile.png';
import orrHistology from '../assets/content-icons/rcc/orr-histology-desktop.png';
import orrHistologyMobile from '../assets/content-icons/rcc/orr-histology-mobile.png';
import isaacBig from '../assets/images/isaacBig.png';
import paul from '../assets/images/paul.png';
import paulBig from '../assets/images/paulBig.png';
import { respondTo } from '../util/breakpoints';
import SecondaryCallout from '../components/SecondaryCallout';
import TextIcon2Column from '../components/TextIcon2Columns';
import vector from "../assets/utility/icons/vector.svg"
import TextIcon1Column from '../components/TextIcon1Column';
import pinchIcon from '../assets/utility/icons/pinch.svg';
// import { jobCodes } from '../util/data/jobCodes';

// SEO INFORMATION
const pageMeta = {
    title: `Advanced Renal Cell Carcinoma (RCC): Efficacy and Safety Data`,
    keywords: `keynote 581, keynote b61`,
    description: `Health care professionals can review efficacy data and safety results for a first-line treatment of adult patients with advanced renal cell carcinoma (RCC).`,
    schemaJsonLD: [
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/advanced-renal-cell-carcinoma/","@type":"ApprovedIndication","name":"KEYTRUDA + LENVIMA","alternateName":"pembrolizumab + lenvatinib","description":"KEYTRUDA, in combination with LENVIMA, is indicated for the first-line treatment of adult patients with advanced renal cell carcinoma (RCC)."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/advanced-renal-cell-carcinoma/","@type":"MedicalAudience","audienceType":"Health Care Professionals","geographicArea":"This site is intended for health care professionals of the United States, its territories, and Puerto Rico."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/advanced-renal-cell-carcinoma/","@type":"MedicalWebPage","name":"Adverse reactions in the KEYNOTE-581/CLEAR trial","description":"The safety of KEYTRUDA + LENVIMA was investigated in the KEYNOTE-581/CLEAR trial in patients treated with KEYTRUDA + LENVIMA (n=352) compared to sunitinib (n=340) at the protocol-specified interim analysis."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/advanced-renal-cell-carcinoma/","@type":"MedicalTrial","name":"KEYNOTE-581/CLEAR Trial","description":"KEYTRUDA + LENVIMA demonstrated superiority in PFS, OS, and ORR vs sunitinib in patients with advanced clear cell RCC","trialDesign":"The KEYNOTE-581/CLEAR trial: A multicenter, randomized, open-label, phase 3 trial with 1,069 patients"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/advanced-renal-cell-carcinoma/","@type":"MedicalEntity","guideline":"NCCN recommends pembrolizumab (KEYTRUDA) + lenvatinib (LENVIMA) as a therapy option for both advanced clear cell (NCCN CATEGORY 1 and PREFERRED, first-line) and non-clear cell renal cell carcinoma (CATEGORY 2A, PREFERRED). ","recognizingAuthority":"National Comprehensive Cancer Network® (NCCN®) "}`
    ]
}

const jobCode = "US-KLR-01018 06/25";



const HeroImage = styled.img`
    max-width: 1032px;
    margin: 0 auto;
    display: block;
`;

const KeytrudaAccordion = styled(Subsection)`
    gap: 20px;
    p{
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
    }
    ${respondTo.md`
        padding-top: 30px;
    `}
    
    &.no-border{
         padding: 0px 30px !important;
         
             &::before{
            display:none!important;
        }
    }
     &.first-accordian{
     margin-top:0px! important;
     }
    .custom-ul{
    display: flex; 
    flex-direction: column;
        gap: 10px;
    li{
    font-size: 16px;
font-weight: 400;
line-height: 20px;
    }
}
`;
const NoborderSubsection = styled(Subsection)`
        &::before{
            display:none!important;
        }
`;
const IconNoBullets = styled(TextIcon1Column)`
    align-items: flex-start;


    ${respondTo.md`
        align-items: center;
    `}

`;
const PageIntro = styled(PageIntroduction)`
    font-weight: 400;
    padding-bottom: 20px;
    gap:30px;
    .flex-20{
    display:flex;
    flex-direction:column;
    gap:20px;
    width: 100%;
    }
    ${respondTo.md`
        padding-bottom: 30px;
         gap:40px;
    `}
`;

const SectionIntro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    .spacer-15--b{
        margin-bottom:15px;
        }
    .mob-b-margin{
    margin-bottom:15px;
    }
    i {
        letter-spacing: 1.2px;
    }
    ${respondTo.md`
        .mob-b-margin{
    margin-bottom:0;
    }
    `}
`;
const AccordionTitle = styled(H4)`
`;
const Subtitle = styled.h5`
    ${HeaderH5Style};
    color: ${colors.greenDark};
    line-height: 18px;
`;

const RccFootnote = styled(Reference)`
    display: flex;
    flex-direction: column;
    gap: 5px;
    i {
        display: contents;
    }
    sup {
        display: flex;
        flex: 0 0 6px;        
        justify-content: center;
    }
    .footNoteSpace{
        padding-top: 20px;
    }
        sup.font-9{
        font-size:9px;
        top:-0.3em;
        }
        .spacer-10--b_mob{
        margin-bottom:10px;
        }
        .pl-footnote{
            padding-left:3.5px;
        }
        ${respondTo.md`
            .spacer-10--b_mob{
            margin-bottom:0;
            }
            `}
`;

const TableRow = styled.div`
    display: flex;
    padding: 15px 10px;
    align-items: center;
    gap: 20px;
    > * {
        flex: 1 1 108px;
        &:first-child {
            flex: 0 0 108px;
        }
    }
    ${respondTo.md`
        padding: 0;
        gap: 0;
        &:nth-child(2n + 1){
            background: ${colors.white};
        }
        > * {
            padding: 18px 30px;
            flex: 1 1 345px;
            &:first-child {
                flex: 0 0 345px;
            }
        }
    `}
    &:has([class*='__Reference']){
        background: ${colors.white};
        padding: 20px;
    }
    [class*='__Reference'] {
        flex-basis: 100%;
        ${respondTo.md`
            padding: 0;
        `}
    }
`;

const TableColumns = styled.div`
    display: flex;
    gap: 5px;
    width: 100%;
    flex-direction: column;
    padding: 0;
    ${respondTo.md`
        padding: 18px 30px;
        gap: 10px;
        flex-direction: row;
        > * {
            flex: 0 0 135px;
        }
        &.second-cell-expanded {
            > :nth-child(2){
                flex: 0 0 175px;
            }
        }
    `}
`;

const EfficacyTableRow = styled.div`
    display: flex;
    padding: 0;
    > * {
        padding: 20px 5px 20px 10px;
        flex: 1 1 90px;
        &:first-child {
            flex: 0 0 90px;
            font-weight: 700;
        }
    }
    ${respondTo.md`
        &:nth-child(2n + 1){
            background: ${colors.white};
        }
        > * {
            padding: 18px 30px;
            flex: 1 1 342px;
            &:first-child {
                flex: 0 0 342px;
            }
            &.full-width {
                flex: 1 1 100%;
                text-align: center;
                font-weight: normal;
                padding: 20px;
            }
        }
    `}
    &:has([class*='__Reference']){
        background: ${colors.white};
        padding: 20px;
    }
    [class*='__Reference'] {
        flex-basis: 100%;
        padding: 0;
        font-weight: 400;
    }
`;

const SingleTableDivs = styled.div`
    display: block;
    align-items: flex-start;
    gap: 10px;
    border-bottom: 1px solid #C4C4C4;
    padding: 20px 5px 20px 10px;

    ${respondTo.md`
        display: flex;
        align-items: center;
        gap: 20px;
        padding-top: 18px;
        padding-bottom: 18px;
        padding-left: 30px;
        padding-right: 30px;
    `}
`;

const EfficacyTableColumns = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 15px 5px;
    align-items: center;
    > * {
        text-align: center;
        flex: 1 0 85px;
    }
    ${respondTo.md`
        padding: 18px 30px;
        > * {
            flex: 1 0 280px;
        }
    `}
`;

const PDTableColumns = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 18px 30px;
    > * {
        text-align: center;
        flex: 1 0 183px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const RccTable = styled(Table)`
    h6{
        padding: 20px 10px;
        text-align: center;
        border-bottom: 1px solid ${colors.pebble};
        ${respondTo.md`
            padding: 30px;
        `}
    }
`;

const RccPrimaryCallout = styled(PrimaryCallout)`

    a img.userIcon {
        width: 12.3px;
        height: 16px;
    }
    &:before {
        border-left: 5px solid ${colors.mulberry};
        background: linear-gradient(96deg, ${colors.brandGreen} 47.42%, ${colors.greenGradient} 100%);
    }
    &.noBorder {
        padding-left: 20px;
        ${respondTo.md`
            padding-left: 0px;
        `}
    }
    &.noBorder:before {
        content: none;
    }
`;

const RccEfficacyIntro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    .spacer-10--b{
    margin-bottom:10px;
    
    }
    h3 {
        ${H4Style};
        ${respondTo.md`
            ${H3Style};
        `}
    }
`;

const RCCEfficacyCallout = styled(PrimaryCallout)`
    [class*='PrimaryCallout__Title-']{
        font-weight: 400;
    }
    i {
        letter-spacing: 1.2px;
    }
    &:before {
        border-left: 5px solid ${colors.mulberry};
        background: linear-gradient(96deg, ${colors.brandGreen} 47.42%, ${colors.greenGradient} 100%);
    }
`;

const OrrChart = styled(Chart)`
    [class*='__ChartTitle']{
        width: 100%;
    }
    ${respondTo.md`
        &.orr {
            img {
                width: 100%;
                margin: 0 auto;
                display: block;
            }
        }
    `}
`;

const EndoTable = styled(Table)`
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    border: 1px solid ${({ type }) => type === 'keytruda' ? colors.brandGreen : type === 'lenvima' ? colors.mulberry : colors.lightGrey};
    h6{
        text-align: center;
    }
      
    > *:first-child {
        padding: 20px 10px;
        background: ${colors.white};
        border-bottom: 1px solid ${({ type }) => type === 'keytruda' ? colors.brandGreen : type === 'lenvima' ? colors.mulberry : colors.lightGrey};
        ${respondTo.md`
             padding: 30px;
        `}
     }

    [class*='__ShadedTableRow'] {
        background: ${colors.white};
    }

    [class*='__ShadedTableColumn'] > *{
        border-bottom: 1px solid ${colors.mist};
        padding:15px 10px;
           ${respondTo.md`
            padding-top: 18px;
    padding-bottom: 18px;
    padding-left: 30px;
    padding-right: 0;
    `}
    }

    [class*='__ShadedTableColumn']:last-child > * {
        &:last-child{
            border-bottom: 0;
        }
    }

    [class*='__ShadedTableColumn']:nth-child(1) > :nth-child(2n){
        background: ${colors.white};
    }

    [class*='__ShadedTableColumn']:nth-child(3) > :nth-child(${({ noOfCells }) => noOfCells === 'odd' ? '2n + 1' : '2n'}){
        background: ${colors.white};
    }

    ${respondTo.md`
        [class*='__ShadedTableColumn']:nth-child(1) > :nth-child(2n){
            background: ${colors.white};
        }
        [class*='__ShadedTableColumn']:nth-child(3) > :nth-child(2n){
            background: ${colors.white};
        }
        [class*='__ShadedTableColumn'] > * {
            &:last-child{
                border-bottom: 0;
            }
        }
    `}

`;

const HypotheticalSubTitle = styled.div`
    font-size: 18px;
    font-style: italic;
    font-weight: 400;
    line-height: 22px;
    padding-bottom: 10px;
    text-align: center;

    ${respondTo.md`
        padding: 0 40px 0;     
    `}
`;
const SingleTableColumn = styled.div`
    width: 100%;

    p:nth-child(1){
        padding-bottom: 10px;
    }

    sup{
        top: -0.6em;
    }

    ${respondTo.md`
        p:nth-child(1){
            padding-bottom: 10px;
            width: 100%;
            max-width: 240px;
        }
    `}
`;
const RCCHypotheticalLast = styled.div`
    p {
        font-size: unset;
        line-height: unset;
    }
`;
const ShadedTableRow = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
    .divider  {
        display: none;
    }
    > :nth-child(3){
        > :last-child {
            border-radius: 0 0 8px 8px;
        }
    }
    .last-element-hidden{
        border-radius: 0 0 8px 8px;
        border-bottom: 0;
    }
    ${respondTo.md`
        flex-direction: row;
        .divider  {
            display: block;
            background: white;
            width: 10px;
            height: 100%;
            border: 1px solid white;
            min-height: 55px;
        }
        > :nth-child(1){
            > :last-child {
                border-radius: 0 0 0px 8px;
            }
        }
        > :nth-child(3){
            > :last-child {
                border-radius: 0 0 8px 0px;
            }
        }
        .last-element-hidden{
            border-radius: 0;
            border-bottom: 1px solid ${colors.mist};
        }
    `}
`;

const HypoOutHorizontalLine = styled.div`
    background: #BEBEBE;
    width: 100%;
    height: 1px;
`;

const ShadedTableColumn = styled.div`
    width: 100%;
    p {
        padding-top: 18px;
        padding-bottom: 18px;
        padding-left: 30px;
        padding-right: 30px;
    }
    ${respondTo.md`
        width: 50%; 
    `}
`;

const PdChart = styled(Chart)`
    [class*='__MobileOnly-']{
        display: flex;
        img{
            border-radius: 0 0 6px 6px;
            padding: 18px 0 0;
        }
    }

    [class*='__ChartTitle']{
        padding: 20px 10px;
    }

    [class*='__ChartChildren']{
        padding: 0;
        [class*='__Body']{
            &.full-width {
                padding: 20px;
                text-align: center;
                border-top: 1px solid ${colors.mist};
            }
        }
    }
`;
const ImgChart = styled(Chart)`
 [class*='__ChartTitle']{
        padding: 20px 10px;
    width:100%;
   
     ${respondTo.md`
        padding:30px;
    `}
     }
    p.padding-mob-0{
    padding:5px;
    
     ${respondTo.md`
        padding:0px;
    `}
    }
    &.chart-padding-20{
    [class*='Chart__ChartChildren']{
        padding:20px;
    }
    }
`;
const ARSection = styled(Section)`
        [class*='Section__SectionIntro']{
        padding-top:40px;
    }
    [class*='__SubsectionContent'] ~ [class*='__SubsectionContent']{
        ${respondTo.md`
            margin-top: 40px;
            padding: 40px 30px 0 30px;
        `}
    }

`;

const FDASection = styled(Section)`
    padding-bottom: 0;
    [class*='__SubsectionContent-']{
        padding-top: 0;
    }
    h6 {
        font-weight: 400;
    }
`;

const NccnCallout = styled(SecondaryCallout)`
    ${PreviewTitleStyle};
    margin: 0 10px 10px 0;
    text-align: center;
    [class*='SecondaryCallout__Title-']{
        font-weight: 400;
    }
`;

const NccnTableMobile = styled(RccTable)`
    [class*='__EfficacyTableRow']{
        > * :first-child {
            flex: 0 0 115px;
        }
        align-items: center;
    }
    [class*='__EfficacyTableColumns']{
        > * {
            flex: 1 0 120px;
        }
    }
`;

const RccReference = styled(Subsection)`
    padding: 40px 20px 0 20px;
    ${respondTo.md`
        padding: 20px 30px 0 30px;
    `}
`;
const HypoHorizontalLine = styled.div`
    background: #BEBEBE;
    width: 100%;
    height: 1px;
    margin: 20px 0px;
`;

const NccnSection = styled(Section)`

        [class*='Section__SectionIntro']{
        padding-top:40px;
        
    }
    [class*='__RccFootnote']{
        div {
            p {
                display: block;
            }
            sup {
                display: inline;
            }
        }
    }
`;

const OSSection = styled.div`
    display: flex;
    gap: 15px;
    flex-direction: column;
    [class*='__TextIcon2ColumnContent']{
    gap:15px;
    .spacer-10--t{
    margin-top:10px;
    }
        img {
            height: 190px;
            margin: 0 auto;
        }
          ${respondTo.md`
        gap: 30px;
    `}   
    }
    i {
        letter-spacing: 1.2px;
    }
    
       [class*='typography__Ul']
       {
       &.spacer-y-15{
        margin-top:15px;
        margin-bottom:15px;
          ${respondTo.md`
       margin-top:10px;
        margin-bottom:10px;
    `} 
       }
    }
      ${respondTo.md`
    gap: 20px;
        
    `}   
`;

const OSContent = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-bottom:15px;
    ${respondTo.md`
        margin-bottom:0px;
    `}  
`;
const MainSection = styled(Section)`
     [class*='Section__SectionIntro']{
        padding-top:40px;
    }
`;

const EndoTableWrapper = styled.div`
picture{
border-bottom: none !important;
}
`;
const PinchContainer = styled.div`
    display: flex;
    gap: 10px;
    color: ${colors.greenDark};
    align-items: center;
`;

const PinchZoomComponent = () => {
    return (
        <MobileOnly>
            <PinchContainer className="pinchContainer">
                <img src={pinchIcon} alt='' />
                <HeaderH6>PINCH TO ZOOM & ENLARGE</HeaderH6>
            </PinchContainer>
        </MobileOnly>
    )
}

const AnchorNavLinks = [

    {
        title: 'Clear Cell RCC',
        href: '#clear-cell-rcc-trial',
        icon: vector,
    },
    {
        title: 'Non-Clear Cell RCC',
        href: '#non-clear-cell-rcc-trial',
        icon: vector,
    },
    {
        title: 'Adverse Reactions',
        href: '#adverse-reaction',
        icon: vector,
    },
    {
        title: 'NCCN Recommendations',
        href: '#nccn-recommendation',
        icon: vector,
    },

];

const RCLinks = [
    {
        eyebrow: 'Safety',
        title: 'Monitor and help manage adverse reactions',
        to: '/treatment-management-and-dose-modifications'
    },
    {
        eyebrow: 'Dosing',
        title: 'Learn more about dosing and administration',
        to: '/dosing'
    },
];

const Rcc = ({ location }) => {
    return (
        <DefaultLayout location={location} name='Advanced Renal Cell Carcinoma: Efficacy and Safety Results' icon={rccIcon} anchorNavLinks={AnchorNavLinks} pageMeta={pageMeta} jobCode={jobCode}>
            <DesktopOnly>
                <HeroImage src={hero} alt='Focus on Possibilities for Treating Your Patients With Advanced RCC' />
            </DesktopOnly>
            <PageIntro>
                <H4><b>Indication</b><br />KEYTRUDA, in combination with LENVIMA, is indicated for the first-line treatment of adult patients with advanced renal cell carcinoma (RCC).</H4>
                <div className='flex-20'>
                    {/* <RCCEfficacyCallout bg='mist' cursor={false}>
                        <div>
                            <b>The FIRST AND ONLY IO combination with data in both advanced clear cell and non-clear cell RCC in the FDA-approved labels.<sup>1-6</sup></b>
                        </div>
                    </RCCEfficacyCallout> */}

                    {/* in */}

                    <NccnCallout noIcon>
                        <H5><b>The FIRST AND ONLY IO combination with data in both advanced clear cell and non-clear cell RCC in the FDA-approved labels.<sup>1&ndash;7</sup></b></H5>

                        <h4><keytitle>KEYTRUDA</keytitle> is an IO (immunotherapy). <lentitle>LENVIMA</lentitle> is a TKI (tyrosine kinase inhibitor).</h4>
                    </NccnCallout>
                    {/* out */}

                </div>
            </PageIntro>
            <MainSection title='Clear Cell RCC' bgColor='cloud' id='clear-cell-rcc-trial'>
                <SectionIntro>
                    <Subtitle>FOCUS ON STUDY DESIGN</Subtitle>
                    <H4><b>The KEYNOTE-581/CLEAR trial:</b> A multicenter, randomized, open-label, phase 3 trial with 1069 patients<sup>6</sup></H4>
                    <Body>Studied in the first-line setting across MSKCC risk groups</Body>
                </SectionIntro>
                <Subsection>
                    <ImgChart imgSrc={mobileChart} desktopImgSrc={desktopChart} noTitle showNote imgAlt='Study Design for KEYNOTE-581/CLEAR Clinical Trial: Key Inclusion/Exclusion Criteria, Stratification Factors, and Major and Additional Endpoints'>
                    </ImgChart>
                    <RccFootnote>
                        <p><sup>a</sup>North America and Western Europe vs “Rest of the World.”</p>
                        <p><sup>b</sup>Randomization was stratified according to Memorial Sloan Kettering Cancer Center (MSKCC) prognostic risk groups: favorable vs intermediate vs poor.</p>
                        <p><sup>c</sup>Clinical data are presented from the KEYTRUDA + LENVIMA and sunitinib arms.</p>
                        <p><sup>d</sup>Administration of KEYTRUDA with LENVIMA was permitted beyond RECIST-defined disease progression, if the patient was clinically stable and considered by the investigator to be deriving clinical benefit.</p>
                        <p>1L = first-line; IRC = independent radiologic review committee; ORR = objective response rate; OS = overall survival; PD-L1 = programmed death ligand 1; PFS = progression-free survival; RECIST v1.1 = Response Evaluation Criteria In Solid Tumors v1.1.</p>
                    </RccFootnote>
                </Subsection>
                <Subsection>
                    <Subtitle>FOCUS ON BASELINE CHARACTERISTICS</Subtitle>

                    <ImgChart imgSrc={moblieCharacter} desktopImgSrc={desktopCharacter} showNote imgAlt='1,069 Patients Were Studied in the First-Line Setting Across MSKCC Risk Groups in KEYNOTE-581/CLEAR Clinical Trial: Baseline Characteristics Including Age, Race, Karnofsky Performance Status, Common Sites of Metastases, and MKSCC Risk Category'>
                        <H6>Studied in the first-line setting across MSKCC risk groups</H6>
                    </ImgChart>
                </Subsection>


                <KeytrudaAccordion>
                    <AccordionTitle>View profiles of hypothetical patients who may be eligible for <keytitle><b>KEYTRUDA</b></keytitle> <b>+</b> <lentitle><b>LENVIMA</b></lentitle></AccordionTitle>
                    <Accordion warningMsg={false} title='Isaac, 63' type='keytruda' descriptionAcc='Widower, second-generation farmer' desImg={isaac}>
                        <div>
                            <TextIcon1Column imgSrc={isaacBig} imgAlt='' effHypoPatientStyle cellType="Clear cell RCC; Intermediate risk">
                                <H6><b>Isaac, 63</b></H6>
                                <Ul>
                                    <li><strong>MSKCC score:</strong> Intermediate risk; Karnofsky performance status: 80%</li>
                                    <li><strong>History of</strong> hypertension, currently controlled on medication<sup>16</sup></li>
                                    <li><strong>Currently experiencing</strong> persistent lower back pain, fatigue, loss of appetite, hematuria, and dyspnea<sup>17,18</sup></li>
                                    <li><strong>Current diagnosis: Stage IV clear cell RCC</strong> (mass in left kidney with multiple lung and lymph node metastases)</li>
                                </Ul>
                                <HypoHorizontalLine>&nbsp;</HypoHorizontalLine>
                                <HypotheticalSubTitle>“My doctor discussed treatment options with me and my family. Together, we will decide what is right for me.”</HypotheticalSubTitle>
                            </TextIcon1Column>
                        </div>

                        <EndoTable type='default' noOfCells='even'>
                            <H6>Assessment and Treatment</H6>
                            <ShadedTableRow>
                                <SingleTableColumn>
                                    <SingleTableDivs>
                                        <Body><b>Laboratory tests:</b></Body>
                                        <Body>Hematuria confirmed by urinalysis with decreased hemoglobin (&lt;LLN)<sup>15</sup></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>CAP CT:</b></Body>
                                        <Body><p>11-cm mass revealed in left kidney</p> 
                                        <p>Lung (largest 13 mm) and lymph node lesions suggestive of metastatic disease<sup>15</sup></p></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>Tumor histology:</b></Body>
                                        <Body>CT-guided biopsy of lung lesions confirmed stage IV clear cell RCC<sup>15</sup></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>First-line treatment:</b></Body>
                                        <Body>KEYTRUDA (200 mg every 3 weeks) + LENVIMA (20 mg once daily)</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>Treatment response:</b></Body>
                                        <Body>At his follow-up appointment after 15 months of KEYTRUDA + LENVIMA, CT scans revealed no disease progression</Body>
                                    </SingleTableDivs>
                                </SingleTableColumn>
                            </ShadedTableRow>
                        </EndoTable>
                        <RCCHypotheticalLast>
                            <RCCEfficacyCallout bg='mist' cursor={false}>
                                <div>
                                    How might <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> fit into your treatment plan</b> for a patient like Isaac with advanced clear cell RCC with intermediate risk?<sup>15</sup>
                                </div>
                            </RCCEfficacyCallout>
                            <RccFootnote>
                                <p className='footNoteSpace'>LLN = lower limit of normal; CAP CT = chest, abdomen, and pelvis computed tomography.</p>
                            </RccFootnote>
                        </RCCHypotheticalLast>
                    </Accordion>



                    <Reference>Hypothetical Patient</Reference>
                </KeytrudaAccordion>
                <NoborderSubsection>
                    <RccPrimaryCallout cursor={false} buttonText='Learn More' buttonTo='https://www.keytrudalenvimahcp.com/static/pdfs/patient-profile-brochure-rcc.pdf' iconType='download'>
                        <div>Explore additional profiles of hypothetical patients who may be appropriate&nbsp;for <keytitle>KEYTRUDA</keytitle>&nbsp;+&nbsp;<lentitle>LENVIMA</lentitle>.</div>
                    </RccPrimaryCallout>
                </NoborderSubsection>


                <Subsection>
                    <RccEfficacyIntro>
                        <div>
                            <H6 className="spacer-10--b">In the protocol-specified interim analysis of the KEYNOTE-581/CLEAR trial:</H6>
                            <H3><b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> demonstrated <b>superiority in PFS, OS, and ORR</b> vs sunitinib in patients with <b>advanced clear cell RCC</b><sup>6</sup></H3>
                        </div>
                        <SectionIntro>
                            <Subtitle>FOCUS ON PROGRESSION-FREE SURVIVAL</Subtitle>
                            <H4><b>Superior PFS with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs sunitinib <b>(HR<sup>e</sup>=0.39; 95% CI, 0.32–0.49; <i>P</i><sup>f</sup>&lt;0.0001)</b> at protocol-specified interim analysis</H4>
                            <Ul marker={colors.charcoal}>
                                <li>Number of events<sup>g</sup>: 160/355 (45%) with KEYTRUDA + LENVIMA vs 205/357 (57%) with sunitinib; Progressive disease: 145/355 (41%) vs 196/357 (55%), respectively; Death: 15/355 (4%) vs 9/357 (3%), respectively.</li>
                                <li><b>Median PFS: 23.9 months</b> (95% CI, 20.8–27.7) with KEYTRUDA + LENVIMA vs <b>9.2 months</b> (95% CI, 6.0–11.0) with sunitinib.</li>
                                <li>PFS and OS were major endpoints in the KEYNOTE-581/CLEAR trial.</li>
                            </Ul>
                            <Reference>HR = hazard ratio; CI = confidence interval.</Reference>
                        </SectionIntro>
                    </RccEfficacyIntro>

                    <RCCEfficacyCallout cursor={false}>
                        <div>
                            <b>2.5x greater median PFS</b> observed with <keytitle><b>KEYTRUDA</b></keytitle> + <lentitle><b>LENVIMA</b></lentitle> (23.9&nbsp;months) vs sunitinib (9.2 months).
                        </div>
                    </RCCEfficacyCallout>
                    <ImgChart imgSrc={mobileEfficacyChart} desktopImgSrc={desktopEfficacyChart} showNote imgAlt='KEYNOTE-581/CLEAR Trial: Kaplan-Meier Estimates of Progression Free Survival With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) (n=355) vs sunitinib (n=357) at the Protocol-specified Interim Analysis'>
                        <H6><b>Kaplan-Meier estimates of PFS with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> (n=355) vs sunitinib (n=357) in the KEYNOTE&#8209;581/CLEAR trial</b></H6>
                        <RccFootnote>
                            <p><sup>e</sup>Hazard ratio is based on a Cox Proportional Hazards Model. Stratified by geographic region and MSKCC prognostic groups.</p>
                            <p><sup>f</sup>Two-sided <i>P</i> value based on stratified log-rank test.</p>
                            <p><sup>g</sup>Tumor assessments were based on RECIST v1.1; data cutoff date = 28 Aug 2020.</p>
                        </RccFootnote>
                    </ImgChart>
                </Subsection>

                <KeytrudaAccordion className="no-border">
                    <Accordion warningMsg={false} title={<><span>Exploratory subgroup analysis of PFS based on selected baseline features<sup>8</sup></span></>} type='keytruda' descriptionAcc='' >
                        <div>
                            <TextIcon1Column   >
                                <H4><b>Exploratory subgroup analysis of PFS</b> for <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs sunitinib in patients with advanced RCC based on selected baseline features<sup>8</sup></H4>
                                <p><b>LIMITATION: The KEYNOTE-581/CLEAR trial was not powered to detect differences in the treatment effect in these subgroups. No statistical testing was planned for this exploratory analysis, and no adjustment for multiplicity was made, therefore, no conclusions can be drawn.</b></p>
                                <p>This exploratory analysis of the KEYNOTE-581/CLEAR trial evaluated PFS for KEYTRUDA + LENVIMA vs sunitinib in patients with advanced RCC with or without specific baseline features, including baseline lung metastases, baseline bone metastases, baseline liver metastases, prior nephrectomy, sarcomatoid component by histology, IMDC risk group, and MSKCC risk group.<sup>a</sup></p>
                                <p>PFS was assessed by IRC according to RECIST v1.1.</p>

                            </TextIcon1Column>
                        </div>
                        <PinchZoomComponent />
                        <EndoTableWrapper>
                        <EndoTable type='default' noOfCells='even'>
                            <H6>PFS by subgroups by IRC per RECIST v1.1</H6>

                            <picture>
                                <source srcSet={pfsMobile} media='(max-width: 768px)' type="image/*" />
                                <img style={{ width: "100%" }} src={pfs} alt='Exploratory Subgroup Analysis of Progression Free Survival for KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) vs sunitinib in Patients With RCC' />
                            </picture>
                             <RCCHypotheticalLast>
 <RccFootnote>
                                <p><sup>a</sup>mPFS for the KEYTRUDA + LENVIMA and sunitinib arms was estimated using the Kaplan-Meier method; HR and 95% CIs comparing KEYTRUDA + LENVIMA with sunitinib were estimated by a stratified Cox model. If a stratification factor was itself a subgroup, this factor was removed from the stratified analysis.</p>
                                <p>ITT = intent to treat; mPFS = median progression-free survival.</p>
                                <p>From <i>Frontiers in Oncology</i>, Grünwald V, et al. Phase 3 CLEAR study in patients with advanced renal cell carcinoma: outcomes in subgroups for the lenvatinib-plus-pembrolizumab and sunitinib arms. <i>Front Oncol</i>. 2023;13:1223282. doi:10.3389/fonc.2023.1223282. Copyright © 2023. Reprinted with permission from <i>Frontiers in</i> <i>Oncology</i>.</p>
                            </RccFootnote>
                             </RCCHypotheticalLast>
                        </EndoTable>
                       </EndoTableWrapper>
                    </Accordion>
                </KeytrudaAccordion>
                <KeytrudaAccordion className="no-border">
                    <Accordion warningMsg={false} title={<><span>Updated PFS at final data cutoff<sup>9</sup></span></>} descriptionAcc='' >
                        <div>
                            <TextIcon1Column>
                                <H4><b>Updated PFS<sup>a,b</sup> at final data cutoff<sup>9</sup></b> </H4>
                                <p><b>LIMITATION: No statistical testing was planned for the updated PFS analysis, and therefore, no conclusions can be drawn.</b></p>
                                <Ul>
                                    <li><strong>HR<sup>c</sup>=0.47 (95% Cl,<sup>d</sup> 0.38–0.57)</strong></li>
                                    <li>Number of events<sup>b</sup>: 207/355 (58%) with KEYTRUDA + LENVIMA vs 214/357 (60%) with sunitinib</li>
                                    <li><strong>Median PFS: 23.9 months</strong> (95% CI, 20.8–27.7) with KEYTRUDA + LENVIMA vs <strong>9.2 months</strong> (95% CI, 6.0–11.0) with sunitinib</li>
                                </Ul>

                            </TextIcon1Column>
                        </div>
                        <PinchZoomComponent />
                        <EndoTableWrapper>
                            <EndoTable type='default' noOfCells='even'>
                                <H6><b>Kaplan-Meier estimates of updated PFS with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> (n=355) vs sunitinib (n=357) in the KEYNOTE-581/CLEAR trial</b> </H6>

                                <picture>
                                    <source srcSet={pfsFinalMobile} media='(max-width: 768px)' type="image/*" />
                                    <img style={{ width: "100%" }} src={pfsFinal} alt='KEYNOTE-581/CLEAR Trial: Kaplan-Meier Estimates of Updated Progression Free Survival With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) (n=355) vs sunitinib (n=357) at the Final Data Cutoff' />
                                </picture>
                                <RCCHypotheticalLast>

                                    <RccFootnote>
                                        <p><sup>a</sup>An updated PFS analysis was conducted when 304 deaths were observed based on the planned number of deaths for the prespecified final analysis.</p>
                                        <p><sup>b</sup>Tumor assessments were based on independent imaging review per RECIST v1.1; updated OS cutoff date = 31 July 2022.</p>
                                        <p><sup>c</sup>Hazard ratio is based on a Cox Proportional Hazards Model. Stratified by geographic region and Memorial Sloan Kettering Cancer Center (MSKCC) prognostic groups.</p>
                                        <p><sup>d</sup>95% CI estimation method using a generalized Brookmeyer and Crowley method.</p>
                                    </RccFootnote>
                                </RCCHypotheticalLast>
                            </EndoTable>
                        </EndoTableWrapper>

                    </Accordion>
                </KeytrudaAccordion>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON OVERALL SURVIVAL</Subtitle>
                        <H4><b>Durable overall survival with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs sunitinib</H4>
                    </SectionIntro>
                    <OSSection>
                        <H6>Superior OS with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs sunitinib demonstrated at protocol-specified interim analysis</H6>
                        <TextIcon2Column>
                            <img src={rccOsIcon} alt='34% Reduced Risk of Death' />
                            <div>

                                <Ul marker={colors.charcoal}>
                                    <li><b>HR<sup>e</sup>=0.66; 95% CI, 0.49–0.88; <i>P</i><sup>f</sup>=0.0049.</b></li>
                                    <li>Number of deaths<sup>h</sup>: 80/355 (23%) with KEYTRUDA + LENVIMA vs 101/357 (28%) with sunitinib.</li>
                                    <li><b>Median OS was not reached (NR) in either arm:</b> KEYTRUDA + LENVIMA (95% CI, 33.6–NR) and sunitinib (95% CI, NR–NR).</li>
                                </Ul>
                                <p className='spacer-10--t'>OS and PFS were major endpoints in the KEYNOTE-581/CLEAR trial.</p>
                            </div>
                        </TextIcon2Column>
                        <RccFootnote>
                            <p><sup>e</sup>Hazard ratio is based on a Cox Proportional Hazards Model. Stratified by geographic region and MSKCC prognostic groups.</p>
                            <p><sup>f</sup>Two-sided <i>P</i> value based on stratified log-rank test.</p>
                            <p><sup>h</sup>Data cutoff date = 28 Aug 2020.</p>
                        </RccFootnote>
                    </OSSection>
                    <OSSection>
                        <H6><b>Updated OS<sup>i,j</sup> at protocol-specified final analysis</b></H6>
                        <OSContent>
                            <Body>This protocol-specified final analysis occurred after the interim analysis, which demonstrated the superiority of OS with KEYTRUDA + LENVIMA vs sunitinib. No statistical testing was planned for the protocol-specified final OS analysis.</Body>
                        </OSContent>
                        <ImgChart imgSrc={rccOsChartMobile} desktopImgSrc={rccOsChartDesktop} showNote imgAlt='KEYNOTE-581/CLEAR Trial: Estimates of Updated OS With KEYTRUDA® (pembrolizumab) + LENVIMA® (lenvatinib) (n=355) vs sunitinib (n=357) at the Protocol-specified Final Analysis'>
                            <H6><b>Kaplan-Meier estimates of updated OS with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> (n=355) vs sunitinib (n=357) in the KEYNOTE&#8209;581/CLEAR trial</b></H6>
                        </ImgChart>
                        <Ul marker={colors.charcoal} className="spacer-y-15">
                            <li><b>HR<sup>e</sup>=0.79 (95% CI, 0.63–0.99).</b></li>
                            <li>Number of deaths<sup>j</sup>: 149/355 (42%) with KEYTRUDA + LENVIMA vs 159/357 (45%) with sunitinib.</li>
                            <li><b>Median OS: 53.7 months</b> (95% CI, 48.7–NR) with KEYTRUDA + LENVIMA vs <b>54.3 months</b> (95% CI, 40.9–NR) with sunitinib.</li>
                        </Ul>
                        <RccFootnote>
                            <p><sup>e</sup>Hazard ratio is based on a Cox Proportional Hazards Model. Stratified by geographic region and MSKCC prognostic groups.</p>
                            <p><sup>i</sup>An updated OS analysis was conducted when 304 deaths were observed based on the planned number of deaths for the prespecified final analysis.</p>
                            <p><sup>j</sup>Updated OS cutoff date = 31 July 2022.</p>
                        </RccFootnote>
                    </OSSection>
                </Subsection>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON OBJECTIVE RESPONSE RATE</Subtitle>
                        <H4>A <b>greater ORR<sup>k</sup></b> was demonstrated with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b>: <b>71% (95% CI, 66–76)</b> vs <b>36% (95% CI, 31–41)</b> with sunitinib <b>(<i>P</i><sup>l</sup>&lt;0.0001)</b> at protocol-specified interim analysis</H4>
                        <p><b>CR</b> was <b>16%</b> with KEYTRUDA + LENVIMA vs <b>4%</b> with sunitinib.</p>
                        <p><b>PR</b> was <b>55%</b> with KEYTRUDA + LENVIMA vs <b>32%</b> with sunitinib.</p>
                        <p>ORR was an additional endpoint in the KEYNOTE-581/CLEAR trial.</p>
                    </SectionIntro>
                    <RCCEfficacyCallout cursor={false}>
                        <div>
                            <b>Nearly 2x greater ORR</b> demonstrated with <keytitle><b>KEYTRUDA</b></keytitle> + <lentitle><b>LENVIMA</b></lentitle> (71%) vs sunitinib (36%) (<i>P</i><sup>l</sup>&lt;0.0001).
                        </div>
                    </RCCEfficacyCallout>
                    <OrrChart imgSrc={mobileOrrChart} desktopImgSrc={desktopOrrChart} showNote className='orr' imgAlt='Response Rates With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) (n=355) vs sunitinib (n=357) in the KEYNOTE-581/CLEAR Trial'>
                        <H6><b>ORR with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> vs sunitinib in the KEYNOTE-581/CLEAR trial<sup>k</sup></b></H6>
                        <RccFootnote>
                            <p><sup>k</sup>Tumor assessments were based on RECIST v1.1; only confirmed responses are included for ORR. Data cutoff date = 28 Aug 2020.</p>
                            <p><sup>l</sup>Two-sided <i>P</i> value based upon CMH test.</p>
                            <p>CR = complete response; PR = partial response; CMH = Cochran-Mantel-Haenszel.</p>
                        </RccFootnote>
                    </OrrChart>
                </Subsection>
                <KeytrudaAccordion className="no-border ">
                    <Accordion warningMsg={false} title={<><span>Updated ORR at final data cutoff<sup>9</sup></span></>} type='keytruda' descriptionAcc='' >
                        <div>
                            <TextIcon1Column>
                                <H4><b>Updated ORR<sup>a</sup> at final data cutoff<sup>9</sup></b></H4>
                                <p><b>LIMITATION: No statistical testing was planned for the updated ORR analysis, and therefore, no conclusions can be drawn.</b></p>
                                <p><b>CR: 18%</b> with KEYTRUDA + LENVIMA vs <b>5%</b> with sunitinib.</p>
                                <p><b>PR<sup>b,c</sup>: 53%</b> with KEYTRUDA + LENVIMA vs <b>32%</b> with sunitinib.</p>

                            </TextIcon1Column>
                        </div>
                        <PinchZoomComponent />
                        <EndoTableWrapper>
                            <EndoTable type='default' noOfCells='even'>
                                <H6>Updated ORR<sup>a</sup> at final data cutoff<sup>9</sup></H6>

                                <picture>
                                    <source srcSet={orrFinalMobile} media='(max-width: 768px)' type="image/*" />
                                    <img style={{ width: "100%" }} src={orrFinal} alt='Response Rates With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) (n=355) vs sunitinib (n=357) Updated ORR at Final Data Cutoff in the KEYNOTE-581/CLEAR Trial' />
                                </picture>
                                <RCCHypotheticalLast>
                                    <RccFootnote>
                                        <p><sup>a</sup>Tumor assessments were based on independent imaging review per RECIST v1.1; only confirmed responses are included for ORR. Updated OS cutoff date = 31 July 2022.</p>
                                        <p><sup>b</sup>Includes 59 patients receiving KEYTRUDA + LENVIMA with a “near CR,” defined as a PR with ≥75% change from baseline in sum of target lesion diameters. </p>
                                        <p><sup>c</sup>Includes 25 patients receiving sunitinib with a “near CR,” defined as a PR with ≥75% change from baseline in sum of target lesion diameters. </p>
                                        <p><sup>d</sup>95% CI is constructed using the method of normal approximation.</p>
                                    </RccFootnote>
                                </RCCHypotheticalLast>
                            </EndoTable>
                        </EndoTableWrapper>
                    </Accordion>
                </KeytrudaAccordion>

            </MainSection>
            <MainSection title='NON-Clear Cell RCC' id='non-clear-cell-rcc-trial'>

                <SectionIntro>
                    <p className='spacer-15--b'><b>Disclaimer: FDA approval was based on the KEYNOTE-581/CLEAR trial for advanced RCC.</b></p>

                    <H4>KEYNOTE-B61: The first clinical trial in advanced or metastatic non-clear cell RCC (N=158) with IO + TKI data included in the FDA-approved labels<sup>10&ndash;13</sup></H4>
                    <p><b>A multicenter, single-arm trial that studied KEYTRUDA + LENVIMA in the first-line setting across IMDC risk groups and histologic subtypes, including papillary and chromophobe histologies</b></p>
                </SectionIntro>
                <Subsection>
                    <ImgChart imgSrc={mobileNonChart} desktopImgSrc={desktopNonChart} noTitle showNote imgAlt='Study Design for KEYNOTE-B61 Clinical Trial: Key Inclusion/Exclusion Criteria and Major and Additional Endpoints'>
                    </ImgChart>
                    <RccFootnote>
                        <p><sup>m</sup>Administration of KEYTRUDA with LENVIMA was permitted beyond RECIST-defined disease progression if the patient was considered by the investigator to be deriving clinical benefit.</p>
                        <p>IMDC = International Metastatic Renal Cell Carcinoma Database Consortium; BICR = blinded independent central review; DOR = duration of response.</p>
                    </RccFootnote>
                </Subsection>
                <Subsection>
                    <ImgChart imgSrc={moblieNonCharacter} desktopImgSrc={desktopNonCharacter} showNote imgAlt='158 Patients Were Studied in the First-Line Setting in the KEYNOTE-B61 Clinical Trial: Baseline Characteristics Including Age, Gender, Baseline Karnofsky Performance Status, Histologic Subtypes, IMDC Risk Category, and Common Sites of Metastases'>
                        <H6>Studied in the first-line setting across IMDC risk groups and histologic subtypes</H6>
                    </ImgChart>

                </Subsection>

                <KeytrudaAccordion>
                    <AccordionTitle>View a hypothetical patients who may be eligible for <keytitle><b>KEYTRUDA</b></keytitle> <b>+</b> <lentitle><b>LENVIMA</b></lentitle></AccordionTitle>
                    <Accordion warningMsg={false} title='Paul, 61' type='keytruda' descriptionAcc='Married father of 3' desImg={paul}>
                        <div>
                            <TextIcon1Column imgSrc={paulBig} imgAlt='' effHypoPatientStyle cellType="Non-clear cell RCC (Papillary)">
                                <H6><b>Paul, 61</b></H6>
                                <Ul>
                                    <li><strong>IMDC risk score:</strong> Intermediate risk; Karnofsky performance status: 80%</li>
                                    <li><strong>Former</strong> smoker with COPD and hypertension, currently controlled on medication<sup>16</sup></li>
                                    <li><strong>Previously diagnosed</strong>  with 7.5-cm stage II papillary RCC, surgically resected via partial nephrectomy of the right kidney<sup>15</sup></li>
                                    <li><strong>Currently experiencing</strong> hip pain and fatigue<sup>17,18</sup></li>
                                    <li><strong>Current diagnosis: Stage IV papillary RCC</strong> (multiple bone and lymph node metastases) </li>
                                </Ul>
                                <HypoHorizontalLine>&nbsp;</HypoHorizontalLine>
                                <HypotheticalSubTitle>“After my surgery I thought my cancer was gone, but I’m determined to continue treatment.”</HypotheticalSubTitle>
                            </TextIcon1Column>
                        </div>

                        <EndoTable type='default' noOfCells='even'>
                            <H6>Assessment and Treatment</H6>
                            <ShadedTableRow>
                                <SingleTableColumn>
                                    <SingleTableDivs>
                                        <Body><b>Laboratory tests:</b></Body>
                                        <Body>Blood test showed increased corrected calcium (10.5 mg/dL)<sup>15</sup></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>CAP CT and bone scan:</b></Body>
                                        <Body>Multiple bone (largest 20 mm) and lymph node (10 mm) lesions suggestive of metastatic disease<sup>15</sup></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>Tumor histology:</b></Body>
                                        <Body>Core needle biopsy of lymph node lesion confirmed stage IV papillary RCC<sup>15</sup></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>First-line treatment:</b></Body>
                                        <Body>KEYTRUDA (400 mg every 6 weeks) + LENVIMA (20 mg once daily)</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                        <Body><b>Treatment response:</b></Body>
                                        <Body>At his follow-up appointment after 12 months of KEYTRUDA + LENVIMA, CT scans revealed a partial response in his lymph metastases</Body>
                                    </SingleTableDivs>
                                </SingleTableColumn>
                            </ShadedTableRow>
                        </EndoTable>
                        <RCCHypotheticalLast>
                            <RCCEfficacyCallout bg='mist' cursor={false}>
                                <div>
                                    How might <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> fit into your treatment plan</b> for a patient like Paul with advanced or metastatic papillary non-clear cell RCC?<sup>15</sup>
                                </div>
                            </RCCEfficacyCallout>
                            <RccFootnote>
                                <p className='footNoteSpace'>COPD = chronic obstructive pulmonary disease; CAP CT = chest, abdomen, and pelvis computed tomography.</p>
                            </RccFootnote>
                        </RCCHypotheticalLast>
                    </Accordion>
                    <Reference>Hypothetical Patient</Reference>
                </KeytrudaAccordion>
                <NoborderSubsection>
                    <RccPrimaryCallout bg='mist' cursor={false} buttonText='Learn More' buttonTo='https://www.keytrudalenvimahcp.com/static/pdfs/patient-profile-brochure-rcc.pdf' iconType='download'>
                        <div>Explore additional profiles of hypothetical patients who may be appropriate for <keytitle>KEYTRUDA</keytitle>&nbsp;+&nbsp;<lentitle>LENVIMA</lentitle>.</div>
                    </RccPrimaryCallout>
                </NoborderSubsection>
                <Subsection>
                    <RccEfficacyIntro>
                        <H3><b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle>:</b> Efficacy results for both <b>ORR and DOR</b> in patients with <b>advanced or metastatic non-clear cell RCC</b></H3>
                        <SectionIntro>
                            <H6>In the single-arm KEYNOTE-B61 trial:</H6>

                            <H4>Half of patients with advanced or metastatic non-clear cell RCC had a <b>confirmed objective response</b> with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b></H4>
                            <p>ORR was the major endpoint in the KEYNOTE-B61 trial.</p>
                            <p><b>ORR<sup><b>n</b></sup>: 51%</b> (95% CI, 43–59) with KEYTRUDA + LENVIMA.</p>
                            <p><b>CR: 8%</b> with KEYTRUDA + LENVIMA.</p>
                            <p><b>PR: 42%</b> with KEYTRUDA + LENVIMA.</p>
                            <p>The sum of PR and CR percentages does not equal that of ORR due to rounding.</p>
                        </SectionIntro>
                    </RccEfficacyIntro>
                    <ImgChart imgSrc={mobileNonEfficacyChart} desktopImgSrc={desktopNonEfficacyChart} showNote imgAlt='Response Rates With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) (N=158) in the KEYNOTE-B61 Clinical Trial'>
                        <H6><b>ORR with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle>  in the KEYNOTE-B61 trial<sup>n</sup></b></H6>
                        <RccFootnote>
                            <p><sup>n</sup>ORR was assessed by BICR using RECIST 1.1.</p>
                        </RccFootnote>
                    </ImgChart>
                </Subsection>
                <KeytrudaAccordion className="no-border ">
                    <Accordion warningMsg={false} title={<><span>ORR by histology</span></>} type='keytruda' descriptionAcc='' >
                        <div>
                            <TextIcon1Column>
                                <p><b>In the single-arm KEYNOTE-B61 trial:</b></p>
                                <H4><b>Confirmed objective response was observed with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> across multiple histologic subtypes</b></H4>
                                <p><b>LIMITATION: No statistical testing was conducted to compare histologic subtypes in this single-arm study. This descriptive analysis is limited by the small sample sizes of each histologic subtype. Therefore, no conclusions can be drawn.</b></p>

                            </TextIcon1Column>
                        </div>
                        <PinchZoomComponent />
                        <EndoTableWrapper>
                            <EndoTable type='default' noOfCells='even'>
                                <H6><b>ORR with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> by histology in the KEYNOTE-B61 trial<sup>a</sup></b></H6>

                                <picture>
                                    <source srcSet={orrHistologyMobile} media='(max-width: 768px)' type="image/*" />
                                    <img style={{ width: "100%" }} src={orrHistology} alt='ORR With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) by Histology in the KEYNOTE-B61 Clinical Trial' />
                                </picture>
                                <RCCHypotheticalLast>
                                    <RccFootnote>
                                        <p><sup>a</sup>Assessed by BICR using RECIST 1.1.</p>
                                        <p><sup>b</sup>Includes other non-clear cell histologic subtypes. </p>
                                    </RccFootnote>
                                </RCCHypotheticalLast>
                            </EndoTable>
                        </EndoTableWrapper>

                    </Accordion>
                </KeytrudaAccordion>
                <Subsection>
                    <SectionIntro>
                        <H6>In the single-arm KEYNOTE-B61 trial:</H6>
                        <H4>A <b>median DOR<sup>o,p</sup> of 19.5 months (range: 1.5+ to 23.5+)</b> was observed with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b></H4>
                    </SectionIntro>
                    <OSSection>
                        <TextIcon2Column>
                            <img src={rccNonOsIcon} alt='Median DOR 19.5 months (range: 1.5+ to 23.5+)' />
                            <div style={{ width: "100%" }}>
                                <p>DOR was an additional endpoint in the KEYNOTE-B61 trial.</p>
                            </div>
                        </TextIcon2Column>
                        <RccFootnote>
                            <p><sup>o</sup>Based on Kaplan-Meier estimates.</p>
                            <p><sup>p</sup>“+” denotes ongoing response.</p>
                        </RccFootnote>
                    </OSSection>
                </Subsection>
            </MainSection>
            <ARSection bgColor='cloud' title='Adverse Reactions' id='adverse-reaction'>
                <SectionIntro>
                    <H3><b>Adverse reactions</b> in the KEYNOTE-581/CLEAR trial</H3>
                    <Body>The safety of KEYTRUDA + LENVIMA was investigated in the KEYNOTE-581/CLEAR trial in patients treated with KEYTRUDA + LENVIMA (n=352) compared to sunitinib (n=340) at the protocol-specified interim analysis.</Body>
                    <Ul marker={colors.charcoal}>
                        <li>The median duration of exposure to KEYTRUDA + LENVIMA was 17 months (range: 0.1 to 39).</li>
                    </Ul>
                </SectionIntro>
                <Subsection>
                    <Subtitle>FOCUS ON FATAL AND SERIOUS ADVERSE REACTIONS</Subtitle>
                    <EndoTable type='default' noOfCells='even'>
                        <H6>Fatal adverse reactions occurred in 4.3% of patients treated with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle>, including cardio-respiratory arrest (0.9%), sepsis (0.9%), and one case (0.3%) each of:</H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Arrhythmia</Body>
                                <Body>Autoimmune hepatitis</Body>
                                <Body>Dyspnea</Body>
                                <Body>Hypertensive crisis</Body>
                                <Body>Increased blood creatinine</Body>
                                <Body>Multiple organ dysfunction syndrome</Body>
                            </ShadedTableColumn>
                            <div className='divider' />
                            <ShadedTableColumn>
                                <Body>Myasthenic syndrome</Body>
                                <Body>Myocarditis</Body>
                                <Body>Nephritis</Body>
                                <Body>Pneumonitis</Body>
                                <Body>Ruptured aneurysm</Body>
                                <Body>Subarachnoid hemorrhage</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <RccPrimaryCallout className='noBorder' cursor={false}>
                        <div>
                            <p>Serious adverse reactions occurred in 51% of patients receiving <keytitle>KEYTRUDA</keytitle>&nbsp;+&nbsp;<lentitle>LENVIMA</lentitle>.</p>
                        </div>
                    </RccPrimaryCallout>
                    <EndoTable type='default' noOfCells='odd'>
                        <H6>Serious adverse reactions in ≥2% of patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> were:</H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Hemorrhagic events (5%)</Body>
                                <Body>Diarrhea (4%)</Body>
                                <Body>Hypertension (3%)</Body>
                                <Body>Myocardial infarction (3%)</Body>
                                <Body>Pneumonitis (3%)</Body>
                            </ShadedTableColumn>
                            <div className='divider' />
                            <ShadedTableColumn>
                                <Body>Vomiting (3%)</Body>
                                <Body>Acute kidney injury (2%)</Body>
                                <Body>Adrenal insufficiency (2%)</Body>
                                <Body>Dyspnea (2%)</Body>
                                <Body>Pneumonia (2%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                </Subsection>
                <Subsection>
                    <Subtitle>FOCUS ON PERMANENT DISCONTINUATION, INTERRUPTION, AND DOSE REDUCTION</Subtitle>
                    <DesktopOnly>
                        <RccTable type='default'>
                            <H6>Permanent discontinuation, dose interruption, and dose reduction due to an adverse reaction in the KEYNOTE&#8209;581/CLEAR trial</H6>
                            <EfficacyTableRow>
                                <Body></Body>
                                <PDTableColumns>
                                    <Body><b>Permanent Discontinuation (%)</b></Body>
                                    <Body><b>Dose<br />Interruption (%)</b></Body>
                                    <Body><b>Dose Reduction (%)</b></Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b><keytitle>KEYTRUDA</keytitle>, <lentitle>LENVIMA</lentitle>, or both</b></Body>
                                <PDTableColumns>
                                    <Body>37</Body>
                                    <Body>78</Body>
                                    <Body>&#8211;</Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b></Body>
                                <PDTableColumns>
                                    <Body>13</Body>
                                    <Body>39</Body>
                                    <Body>&#8211;</Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b><keytitle>KEYTRUDA</keytitle> only</b></Body>
                                <PDTableColumns>
                                    <Body>29</Body>
                                    <Body>55</Body>
                                    <Body>&#8211;</Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b><lentitle>LENVIMA</lentitle> only</b></Body>
                                <PDTableColumns>
                                    <Body>26</Body>
                                    <Body>73</Body>
                                    <Body>69</Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body className='full-width'>No dose reduction for <b><keytitle>KEYTRUDA</keytitle></b> is recommended.</Body>
                            </EfficacyTableRow>
                        </RccTable>
                    </DesktopOnly>
                    <MobileOnly>
                        <PdChart imgSrc={modilePdImage} showNote imgAlt='Permanent Discontinuation, Dose Interruption, and Dose Reduction due to an Adverse Reaction in the KEYNOTE‑581/CLEAR Trial'>
                            <H6>Permanent discontinuation, dose interruption, and dose reduction due to an adverse reaction in the KEYNOTE-581/CLEAR trial</H6>
                            <Body className='full-width'>No dose reduction for <b><keytitle>KEYTRUDA</keytitle></b> is recommended.</Body>
                        </PdChart>
                    </MobileOnly>
                    <EndoTable type='default' noOfCells='odd'>
                        <H6>Most common (≥2%) adverse reactions that resulted in permanent discontinuation of <keytitle>KEYTRUDA</keytitle>, <lentitle>LENVIMA</lentitle>, or&nbsp;both</H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Pneumonitis (3%)</Body>
                                <Body>Myocardial infarction (3%)</Body>
                                <Body>Hepatotoxicity (3%)</Body>
                            </ShadedTableColumn>
                            <div className='divider' />
                            <ShadedTableColumn>
                                <Body>Acute kidney injury (3%)</Body>
                                <Body>Rash (3%)</Body>
                                <Body>Diarrhea (2%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <EndoTable type='keytruda' noOfCells='odd'>
                        <H6>Most common (≥3%) adverse reactions in patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> that resulted in interruption of <keytitle>KEYTRUDA</keytitle></H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Diarrhea (10%)</Body>
                                <Body>Hepatotoxicity (8%)</Body>
                                <Body>Fatigue (7%)</Body>
                                <Body>Lipase increased (5%)</Body>
                                <Body>Amylase increased (4%)</Body>
                            </ShadedTableColumn>
                            <div className='divider' />
                            <ShadedTableColumn>
                                <Body>Musculoskeletal pain (3%)</Body>
                                <Body>Hypertension (3%)</Body>
                                <Body>Rash (3%)</Body>
                                <Body>Acute kidney injury (3%)</Body>
                                <Body>Decreased appetite (3%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <EndoTable type='lenvima' noOfCells='even'>
                        <H6>Most common (≥5%) adverse reactions in patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> that resulted in dose reduction or interruption of <lentitle>LENVIMA</lentitle></H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Diarrhea (26%)</Body>
                                <Body>Fatigue (18%)</Body>
                                <Body>Hypertension (17%)</Body>
                                <Body>Proteinuria (13%)</Body>
                                <Body>Decreased appetite (12%)</Body>
                                <Body>Palmar-plantar erythrodysesthesia (11%)</Body>
                                <Body>Nausea (9%)</Body>
                                <Body>Stomatitis (9%)</Body>
                            </ShadedTableColumn>
                            <div className='divider' />
                            <ShadedTableColumn>
                                <Body>Musculoskeletal pain (8%)</Body>
                                <Body>Rash (8%)</Body>
                                <Body>Increased lipase (7%)</Body>
                                <Body>Abdominal pain (6%)</Body>
                                <Body>Vomiting (6%)</Body>
                                <Body>Increased ALT (5%)</Body>
                                <Body className='last-element-hidden'>Increased amylase (5%)</Body>
                                <DesktopOnly><Body></Body></DesktopOnly>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <RccFootnote>
                        <p>ALT = alanine aminotransferase.</p>
                    </RccFootnote>
                </Subsection>
                <Subsection>
                    <Subtitle>FOCUS ON MOST COMMON ADVERSE REACTIONS</Subtitle>
                    <ImgChart className="chart-padding-20" imgSrc={commonArMobile} desktopImgSrc={commonArDesktop} showNote imgAlt='Adverse Reactions That Occurred in ≥20% of Patients Receiving KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) in the KEYNOTE-581/CLEAR Trial'>
                        <H6>Adverse reactions that occurred in ≥20% of patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> in the KEYNOTE&#8209;581/CLEAR trial</H6>
                        <RccFootnote>
                            <p className='pl-footnote'><sup>q</sup>Includes asthenia, fatigue, lethargy, malaise.</p>
                            <p className='pl-footnote'><sup>r</sup>Includes diarrhea, gastroenteritis.</p>
                            <p className='pl-footnote'><sup>s</sup>Includes arthralgia, arthritis, back pain, bone pain, breast pain, musculoskeletal chest pain, musculoskeletal discomfort, musculoskeletal pain, musculoskeletal stiffness, myalgia, neck pain, non-cardiac chest pain, pain in extremity, pain in jaw.</p>
                            <p className='pl-footnote'><sup>t</sup>Includes hypothyroidism, increased blood thyroid stimulating hormone, secondary hypothyroidism.</p>
                            <p className='pl-footnote'><sup>u</sup>Includes essential hypertension, increased blood pressure, increased diastolic blood pressure, hypertension, hypertensive crisis, hypertensive retinopathy, labile blood pressure.</p>
                            <p className='pl-footnote'><sup>v</sup>Includes aphthous ulcer, gingival pain, glossitis, glossodynia, mouth ulceration, mucosal inflammation, oral discomfort, oral mucosal blistering, oral pain, oropharyngeal pain, pharyngeal inflammation, stomatitis.</p>
                            <p className='pl-footnote'><sup>w</sup>Includes decreased appetite, early satiety.</p>
                            <p className='pl-footnote'><sup>x</sup>Includes genital rash, infusion site rash, penile rash, perineal rash, rash, rash erythematous, rash macular, rash maculo-papular, rash papular, rash pruritic, rash pustular.</p>
                            <p className='pl-footnote'><sup>y</sup>Includes hemoglobinuria, nephrotic syndrome, proteinuria.</p>
                            <p className='pl-footnote'><sup>z</sup>Includes palmar erythema, palmar-plantar erythrodysesthesia syndrome, plantar erythema.</p>
                            <p><sup>aa</sup>Includes all hemorrhage terms. Hemorrhage terms that occurred in 1 or more subjects in either treatment group include anal hemorrhage, aneurysm ruptured, blood blister, blood loss anemia, blood urine present, catheter site hematoma, cerebral microhemorrhage, conjunctival hemorrhage, contusion, diarrhea hemorrhagic, disseminated intravascular coagulation, ecchymosis, epistaxis, eye hemorrhage, gastric hemorrhage, gastritis hemorrhagic, gingival bleeding, hemorrhage urinary tract, hemothorax, hematemesis, hematoma, hematochezia, hematuria, hemoptysis, hemorrhoidal hemorrhage, increased tendency to bruise, injection site hematoma, injection site hemorrhage, intra-abdominal hemorrhage, lower gastrointestinal hemorrhage, Mallory-Weiss syndrome, melaena, petechiae, rectal hemorrhage, renal hemorrhage, retroperitoneal hemorrhage, small intestinal hemorrhage, splinter hemorrhages, subcutaneous hematoma, subdural hematoma, subarachnoid hemorrhage, thrombotic thrombocytopenic purpura, tumor hemorrhage, traumatic hematoma, upper gastrointestinal hemorrhage.</p>
                            <p><sup>bb</sup>Includes abdominal discomfort, abdominal pain, abdominal rigidity, abdominal tenderness, epigastric discomfort, lower abdominal pain, upper abdominal pain.</p>
                            <p><sup>cc</sup>Includes alanine aminotransferase increased, aspartate aminotransferase increased, blood bilirubin increased, drug-induced liver injury, hepatic enzyme increased, hepatic failure, hepatic function abnormal, hepatocellular injury, hepatotoxicity, hyperbilirubinemia, hypertransaminasemia, immune-mediated hepatitis, liver function test increased, liver injury, transaminases increased, gamma-glutamyltransferase increased.</p>
                            <p><sup>dd</sup>Includes acute kidney injury, azotemia, blood creatinine increased, creatinine renal clearance decreased, hypercreatininemia, renal failure, renal impairment, oliguria, glomerular filtration rate decreased, nephropathy toxic.</p>
                        </RccFootnote>
                    </ImgChart>
                    <Ul marker={colors.charcoal}>
                        <li>Fifteen percent (15%) of patients treated with KEYTRUDA + LENVIMA received an oral prednisone equivalent to ≥40 mg daily for an immune-mediated adverse reaction.</li>
                        <li>Clinically relevant adverse reactions (&lt;20%) that occurred in patients receiving KEYTRUDA + LENVIMA were myocardial infarction (3%) and angina pectoris (1%).</li>
                        <li>Grade 3 and 4 increased ALT or AST was seen in 9% of patients. Grade ≥2 increased ALT or AST was reported in 64 (18%) patients, of whom 20 (31%) received ≥40 mg daily oral prednisone equivalent. Recurrence of Grade ≥2 increased ALT or AST was observed on rechallenge in 3 patients receiving LENVIMA, in 10 patients receiving both KEYTRUDA and LENVIMA (n=38), and was not observed on rechallenge with KEYTRUDA alone (n=3).</li>
                    </Ul>
                    <Reference>
                        AST = aspartate aminotransferase.
                    </Reference>

                </Subsection>
                <KeytrudaAccordion className="no-border">
                    <Accordion warningMsg={false} title={<><span>Median time to first onset of select adverse reactions<sup>14</sup></span></>} type='keytruda' descriptionAcc='' >
                        <div>
                            <TextIcon1Column>
                                <H4><b>Post hoc analysis:</b> Median time to first onset of select adverse reactions in KEYNOTE-581/CLEAR (n=352)<sup>14</sup></H4>
                                <p><b>LIMITATION: This is a post hoc analysis based on data from KEYNOTE-581/CLEAR. No formal statistical testing was planned and, therefore, no conclusions can be drawn.</b></p>
                                <Ul marker={colors.charcoal} style={{ paddingLeft: 13}} className='custom-ul'>
                                    <li>As this information is descriptive only, it may not be reflective of clinical practice; it should not replace physician judgement and evaluation of a potential adverse reaction should it occur.</li>
                                    <li>Health care professionals should monitor and evaluate patients for the presence of potential adverse reactions throughout treatment with KEYTRUDA, in combination with LENVIMA, and following discontinuation.</li>
                                    <li>Immune-mediated adverse reactions can occur at any time after starting treatment with a PD-1/PD-L1 blocking antibody. While immune-mediated adverse reactions usually manifest during treatment with PD-1/PD-L1 blocking antibodies, immune-mediated adverse reactions can also manifest after discontinuation of PD-1/PD-L1 blocking antibodies.</li>
                                    <li>Data does not represent a complete list of each adverse reaction that occurred during the CLEAR trial.</li>
                                    <li>The interquartile range (Q1:Q3) represents the time to onset (the earliest treatment-emergent adverse reaction [AR] start date) for the AR for the middle 50% of patients who experienced that AR from quartile 1 to quartile 3.</li>
                                    <li>ARs were chosen based on frequency of occurrence (in ≥30% of patients). ARs could have occurred while receiving LENVIMA and/or KEYTRUDA or within the protocol-defined follow-up period of 30 days after the patient’s last dose. ARs were recorded until the end of the follow-up period or until resolution, whichever came first. Grading of ARs was performed according to Common Terminology Criteria for Adverse Events v4.03.</li>
                                </Ul>

                            </TextIcon1Column>
                        </div>
                        <PinchZoomComponent />
                        <EndoTableWrapper>
                        <EndoTable type='default' noOfCells='even'>
                            <picture>
                                <source srcSet={medianTimeMobile} media='(max-width: 768px)' type="image/*" />
                                <img style={{ width: "100%" }} src={medianTime} alt='Post Hoc Analysis of Median Time to First Onset of Select Adverse Reactions of Patients Receiving KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) in KEYNOTE-581/CLEAR Trial (n=352)' />
                            </picture>
                             <RCCHypotheticalLast>

                            <RccFootnote>
                                <p className='footNoteSpace'><sup>a</sup>Median time to first onset in patients who experienced the adverse reaction. Gray boxes represent Q1–Q3. Lines represent the range. </p>
                                <p><sup>b</sup>Any grade. </p>
                                <p><sup>c</sup>Percentages are based on the safety population of the KEYTRUDA + LENVIMA group (n=352). The safety population included all patients who received at least 1 dose of any study drug. </p>
                                <p><sup>d</sup>Includes essential hypertension, increased blood pressure, increased diastolic blood pressure, hypertension, hypertensive crisis, hypertensive retinopathy, and labile blood pressure. </p>
                                <p><sup>e</sup>Includes fatigue, asthenia, malaise, and lethargy. </p>
                                <p><sup>f</sup>Includes hemoglobinuria, nephrotic syndrome, and proteinuria. </p>
                                <p><sup>g</sup>Includes arthralgia, arthritis, back pain, bone pain, breast pain, musculoskeletal chest pain, musculoskeletal discomfort, musculoskeletal pain, musculoskeletal stiffness, myalgia, neck pain, noncardiac chest pain, pain in extremity, and pain in jaw. </p>
                                <p><sup>h</sup>Includes aphthous ulcer, gingival pain, glossitis, glossodynia, mouth ulceration, mucosal inflammation, oral discomfort, oral mucosal blistering, oral pain, oropharyngeal pain, pharyngeal inflammation, and stomatitis. </p>
                                <p><sup>i</sup>Includes genital rash, infusion site rash, penile rash, rash, rash erythematous, rash macular, rash maculo-papular, rash papular, rash pruritic, and rash pustular. </p>
                                <p><sup>j</sup>Includes hypothyroidism, increased blood thyroid-stimulating hormone, and secondary hypothyroidism.</p>
                                <p><sup>k</sup>Includes decreased appetite and early satiety.</p>
                                <p><sup>l</sup>Includes diarrhea and gastroenteritis.</p>
                                <p>PD-1 = programmed death receptor-1.</p>
                                <p>Adapted with permission from Motzer R, George S, Merchan JR, et al. Characterization and management of adverse reactions from the CLEAR study in advanced renal cell carcinoma treated with lenvatinib plus pembrolizumab. <i>Oncologist.</i> 2023;28(6):501–509. doi:10.1093/oncolo/oyac269</p>
                            </RccFootnote>
                        </RCCHypotheticalLast>
                        </EndoTable>
                       </EndoTableWrapper>
                    </Accordion>
                </KeytrudaAccordion>
            </ARSection>
            <FDASection>
                <SectionIntro>
                    <H6><b>FDA-APPROVED INDICATION</b><br />KEYTRUDA, in combination with LENVIMA, is indicated for the first-line treatment of adult patients with advanced renal cell carcinoma (RCC).</H6>
                </SectionIntro>
                <Subsection></Subsection>
            </FDASection>
            <NccnSection title='NCCN RECOMMENDATIONS' id='nccn-recommendation'>
                <SectionIntro>
                    <div className='mob-b-margin'>
                        <H6><b>National Comprehensive Cancer Network<sup>®</sup> (NCCN<sup>®</sup>) PREFERRED Recommendation in advanced clear cell and non-clear cell RCC<sup>15</sup></b></H6>
                    </div>
                    <NccnCallout noIcon>

                        <p>NCCN recommends pembrolizumab (<keytitle><b>KEYTRUDA</b></keytitle>) + lenvatinib (<lentitle><b>LENVIMA</b></lentitle>) as a therapy option for both advanced clear cell (<b>NCCN CATEGORY 1</b> and <b>PREFERRED, first-line</b>) and non-clear cell renal cell carcinoma (<b>CATEGORY 2A, PREFERRED</b>).<sup>15</sup></p>
                    </NccnCallout>
                </SectionIntro>
                <Subsection>
                    <DesktopOnly>
                        <RccTable type='default'>
                            <H6>NCCN Recommendations for advanced clear cell RCC according to MSKCC and IMDC risk categories<sup>15</sup></H6>
                            <EfficacyTableRow>
                                <Body></Body>
                                <PDTableColumns>
                                    <Body><b>Favorable</b></Body>
                                    <Body><b>Intermediate</b></Body>
                                    <Body><b>Poor</b></Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b><keytitle>Pembrolizumab (KEYTRUDA)</keytitle> + <lentitle>Lenvatinib (LENVIMA)</lentitle></b></Body>
                                <PDTableColumns>
                                    <Body><b><TableSpan>CATEGORY 1</TableSpan><br />PREFERRED</b></Body>
                                    <Body><b><TableSpan>CATEGORY 1</TableSpan><br />PREFERRED</b></Body>
                                    <Body><b><TableSpan>CATEGORY 1</TableSpan><br />PREFERRED</b></Body>
                                </PDTableColumns>
                            </EfficacyTableRow>
                        </RccTable>
                    </DesktopOnly>
                    <MobileOnly>
                        <NccnTableMobile type='default'>
                            <H6>NCCN Recommendations for advanced clear cell RCC according to MSKCC and IMDC risk categories<sup>15</sup></H6>
                            <EfficacyTableRow>
                                <Body></Body>
                                <EfficacyTableColumns>
                                    <Body><b><keytitle>Pembrolizumab (KEYTRUDA)</keytitle> +<br /><lentitle>Lenvatinib (LENVIMA)</lentitle></b></Body>
                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b>Favorable</b></Body>
                                <EfficacyTableColumns>
                                    <Body><b><TableSpan>CATEGORY 1</TableSpan><br />PREFERRED</b></Body>

                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b>Intermediate</b></Body>
                                <EfficacyTableColumns>
                                    <Body><b><TableSpan>CATEGORY 1</TableSpan><br />PREFERRED</b></Body>

                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b>Poor</b></Body>
                                <EfficacyTableColumns>
                                    <Body><b><TableSpan>CATEGORY 1</TableSpan><br />PREFERRED</b></Body>

                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                        </NccnTableMobile>
                    </MobileOnly>

                    <RccFootnote>
                        <p>NCCN makes no warranties of any kind whatsoever regarding their content, use, or application and disclaims any responsibility for their application or use in any way.</p>
                        <div><p>Category 1: Based upon high-level evidence (≥1 randomized phase 3 trials or high-quality, robust meta-analyses), there is uniform NCCN consensus (≥85% support of the Panel) that the intervention is appropriate.<sup>15</sup></p></div>
                        <div><p>Category 2A: Based upon lower-level evidence, there is uniform NCCN consensus (≥85% support of the Panel) that the intervention is appropriate.<sup>15</sup></p></div>
                    </RccFootnote>
                </Subsection>
            </NccnSection>
            <RelatedContent title='Learn more about adverse reaction management and dosing' links={RCLinks} />
            <Section noIntro>
                <RccReference>
                    <Reference>
                        <b>References: 1.</b> Bavencio. Prescribing information. EMD Serono, Inc; 2024. <b>2.</b> Opdivo. Prescribing information. Bristol-Myers Squibb Company; 2025. <b>3.</b> Identifier: NCT02231749. Nivolumab combined with ipilimumab versus sunitinib in previously untreated advanced or metastatic renal cell carcinoma (CheckMate 214). ClinicalTrials.gov. Updated June 26, 2025. Accessed June 27, 2025. https://clinicaltrials.gov/study/NCT02231749 <b>4.</b> Identifier: NCT03141177. A study of nivolumab combined with cabozantinib compared to sunitinib in previously untreated advanced or metastatic renal cell carcinoma (CheckMate 9ER). ClinicalTrials.gov. Updated June 6, 2025. Accessed June 25, 2025. https://clinicaltrials.gov/study/NCT03141177 <b>5.</b> Identifier: NCT02684006. A study of avelumab with axitinib versus sunitinib in advanced renal cell cancer (JAVELIN renal 101). ClinicalTrials.gov. Updated October 29, 2024. Accessed February 11, 2025. https://clinicaltrials.gov/study/NCT02684006 <b>6.</b> Motzer R, Alekseev B, Rha SY, et al. Lenvatinib plus pembrolizumab or everolimus for advanced renal cell carcinoma. <i>N Engl J Med.</i> 2021;384(14):1289–1300. doi:10.1056/NEJMoa2035716
                        <b> 7.</b> Identifier: NCT01668784. Study of nivolumab (BMS-936558) vs. everolimus in pre-treated advanced or metastatic clear-cell renal cell carcinoma (CheckMate 025). ClinicalTrials.gov. Updated August 9, 2022. Accessed December 11, 2024. https://clinicaltrials.gov/study/NCT01668784 <b>8.</b> Grünwald V, Powles T, Eto M, et al. Phase 3 CLEAR study in patients with advanced renal cell carcinoma: outcomes in subgroups for the lenvatinib-plus-pembrolizumab and sunitinib arms. <i>Front Oncol.</i> 2023;13:1223282. doi:10.3389/fonc.2023.1223282 <b>9.</b> Motzer R, Porta C, Eto M, et al. Lenvatinib plus pembrolizumab versus sunitinib in first-line treatment of advanced renal cell carcinoma: final prespecified overall survival analysis of CLEAR, a phase III study. <i>J Clin Oncol.</i> 2024;42(11):1222–1228. doi:10.1200/JCO.23.01569 <b>10.</b> Stellato M, Buti S, Maruzzo M, et al. Pembrolizumab plus axitinib for metastatic papillary and chromophobe renal cell carcinoma: NEMESIA (Non Clear MEtaStatic Renal Cell Carcinoma Pembrolizumab Axitinib) study, a subgroup analysis of I-RARE observational study (Meet-URO 23a). <i>Int J Mol Sci.</i> 2023;24(2):1096. doi:org/10.3390/ijms24021096 <b>11.</b> Dong P, Wei W, Jiang L, et al. Anlotinib combined with sintilimab as first-line treatment in patients with advanced non-clear cell renal cell carcinoma: preliminary results from an exploratory prospective clinical study. <i>J Clin Oncol.</i> 2023;41(suppl 16):e16546–e16546. doi:10.1200/JCO.2023.41.16_suppl.e16546 <b>12.</b> McGregor BA, McKay RR, Braun DA, et al. Results of a multicenter phase II study of atezolizumab and bevacizumab for patients with metastatic renal cell carcinoma with variant histology and/or sarcomatoid features. <i>J Clin Oncol.</i> 2020;38(1):63–70. doi:10.1200/JCO.19.01882 <b>13.</b> Lee CH, Voss MH, Carlo MI, et al. Phase II trial of cabozantinib plus nivolumab in patients with non-clear-cell renal cell carcinoma and genomic correlates. <i>J Clin Oncol.</i> 2022;40(21):2333–2341. doi:10.1200/JCO.21.01944 <b>14.</b> Motzer R, George S, Merchan JR, et al. Characterization and management of adverse reactions from the CLEAR study in advanced renal cell carcinoma treated with lenvatinib plus pembrolizumab. <i>Oncologist.</i> 2023;28(6):501–509. doi:10.1093/oncolo/oyac269 <b>15.</b> Referenced with permission from the NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®) for Kidney Cancer V.3.2025. © National Comprehensive Cancer Network, Inc. 2025. All rights reserved. Accessed January 13, 2025. To view the most recent and complete version of the guideline, go online to NCCN.org. <b>16.</b> American Cancer Society. Risk factors for kidney cancer. Revised May 1, 2024. Accessed May 21, 2025. https://www.cancer.org/cancer/types/kidney-cancer/causes-risks-prevention/risk-factors.html <b>17.</b> American Cancer Society. Kidney cancer signs and symptoms. Revised May 1, 2024. Accessed June 25, 2025. https://www.cancer.org/cancer/kidney-cancer/detection-diagnosis-staging/signs-and-symptoms.html <b>18.</b> American Cancer Society. What are advanced and metastatic cancers? Revised July 9, 2024. Accessed November 27, 2024. https://www.cancer.org/treatment/understanding-your-diagnosis/advanced-cancer/what-is.html

                    </Reference>
                </RccReference>
            </Section>
        </DefaultLayout>
    )
};

export default Rcc;
